<template>
  <image-header-page
    :image-header-props="imageHeaderProps"
    :sticky-header="false"
  >
    <template v-slot:header>
      <div class="header-container">
        <div v-if="withRibbon">
          <days-until-ribbon
            class="ribbon"
            :number-of-days-left="timeUntilChallengeStart"
          />
        </div>
        <challenge-header v-bind="challengeHeaderProps" />
      </div>
    </template>
    <template v-slot:overlayContent>
      <slot name="cards" />
    </template>
    <template v-slot>
      <div :class="['padding-horizontal-ml', { 'padding-top-l': !slots.cards }]">
        <slot name="info" />
      </div>
    </template>
  </image-header-page>
</template>

<script lang="ts" setup>
import { COLOR_VARIANT, BACKGROUND_POSITION } from '@riseupil/base-ui/src/utils/layout-consts';
import ImageHeaderPage from '@riseupil/base-ui/src/templates/ImageHeaderPage.vue';
import { useSlots } from 'vue';
import DaysUntilRibbon from './Ribbon/DaysUntilRibbon.vue';
import headerImage from '../assets/header-backgrounds/generic-challenge.png';
import ChallengeHeader from '../components/ChallengeHeader/ChallengeHeader.vue';
import { DescriptionSize } from '../components/ChallengeHeader/DescriptionSize';

const imageHeaderProps = {
  title: '',
  imgSrc: headerImage,
  backgroundColor: COLOR_VARIANT.GREEN,
  backgroundPosition: BACKGROUND_POSITION.BOTTOM_LEFT,
  textColor: COLOR_VARIANT.BEIGE,
  bottomSeparator: false,
};
interface Props {
  withRibbon?: boolean;
  timeUntilChallengeStart: number;
  challengeHeaderProps: {
    challengeName: string;
    shortDescription?: string;
    descriptionSize?: DescriptionSize;
  };
}

withDefaults(
  defineProps<Props>(),
  { withRibbon: false },
);

const slots = useSlots();
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
</style>
